<div class="container">
    <aside class="sidebar">
        <ul>
            <li [class.active]="selectedTab == Tab.User" (click)="selectTab(Tab.User)">User</li>
            <li [class.active]="selectedTab == Tab.RoundUploader" (click)="selectTab(Tab.RoundUploader)">Round uploader</li>
            <li [class.active]="selectedTab == Tab.PromoCodes" (click)="selectTab(Tab.PromoCodes)">Promo codes</li>
        </ul>
    </aside>

    <main class="content">
        <div *ngIf="selectedTab == Tab.User">
            <div class="tab-container">
                <search [(user)]=user/>
                <search-result [user]=user()/>
                <change-login [(user)]="user"/>
            </div>
        </div>
        <div *ngIf="selectedTab == Tab.RoundUploader">
            <upload/>
        </div>
        <div *ngIf="selectedTab == Tab.PromoCodes">
            <promo-codes/>
        </div>
    </main>
</div>